import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import csTranslations from './locales/cs.json';

// Definujeme podporované lokality
export const supportedLocales = {
  'en-US': { label: 'English (US)' },
  'en-GB': { label: 'English (GB)' },
  'cs-CZ': { label: 'Čeština' },
};

i18n
  // Detekce jazyka z prohlížeče
  .use(LanguageDetector)
  // Propojení s Reactem
  .use(initReactI18next)
  .init({
    // Naše překlady
    resources: {
      // Pro jednoduchost používáme jeden 'en' soubor pro všechny anglické varianty
      en: { translation: enTranslations },
      cs: { translation: csTranslations },
    },
    // Jazyky, které se mají načíst, pokud specifická lokalita neexistuje
    // např. pro 'en-GB' se použije 'en'
    fallbackLng: 'en-US',
    debug: false, // V produkci vypnout na false
    
    // Nastavení detektoru jazyka
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React si s XSS poradí sám
    },

    // Kompatibilita s plnými kódy lokalit (en-US) i jen s jazyky (en)
    load: 'languageOnly', // Načítáme 'en' nebo 'cs', ale formátování bude dle plné lokality
  });

export default i18n;